/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findManyProgramPeriods } from '../fn/program-periods/find-many-program-periods';
import { FindManyProgramPeriods$Params } from '../fn/program-periods/find-many-program-periods';
import { findOneProgramPeriod } from '../fn/program-periods/find-one-program-period';
import { FindOneProgramPeriod$Params } from '../fn/program-periods/find-one-program-period';
import { ProgramPeriod } from '../models/program-period';

@Injectable({ providedIn: 'root' })
export class ProgramPeriodsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `programPeriodControllerFindOneProgramPeriod()` */
  static readonly ProgramPeriodControllerFindOneProgramPeriodPath =
    '/program/{programSlug}/periods/{programPeriodSlug}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneProgramPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneProgramPeriod$Response(
    params: FindOneProgramPeriod$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriod>> {
    return findOneProgramPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneProgramPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneProgramPeriod(params: FindOneProgramPeriod$Params, context?: HttpContext): Observable<ProgramPeriod> {
    return this.findOneProgramPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriod>): ProgramPeriod => r.body)
    );
  }

  /** Path part for operation `programPeriodControllerFindManyProgramPeriods()` */
  static readonly ProgramPeriodControllerFindManyProgramPeriodsPath = '/program/{programSlug}/periods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findManyProgramPeriods()` instead.
   *
   * This method doesn't expect any request body.
   */
  findManyProgramPeriods$Response(
    params: FindManyProgramPeriods$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ProgramPeriod>>> {
    return findManyProgramPeriods(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findManyProgramPeriods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findManyProgramPeriods(
    params: FindManyProgramPeriods$Params,
    context?: HttpContext
  ): Observable<Array<ProgramPeriod>> {
    return this.findManyProgramPeriods$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProgramPeriod>>): Array<ProgramPeriod> => r.body)
    );
  }
}
